import Router from "./routes";
// theme
import ThemeProvider from "./theme";
import { styled } from "@mui/material/styles";
import ThemeSettings from "./components/settings";
import { ChartStyle } from "./components/chart";
import ScrollToTop from "./components/ScrollToTop";
import { ProgressBarStyle } from "./components/ProgressBar";
import NotistackProvider from "./components/NotistackProvider";
import MotionLazyContainer from "./components/animate/MotionLazyContainer";

const RootStyle = styled("div")(({ theme }) => ({
  background: "#e7e7e7",
  [theme.breakpoints.up("md")]: {
    display: "block",
  },
}));

export default function App() {
  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <ThemeSettings>
          <NotistackProvider>
            <ProgressBarStyle />
            <ChartStyle />
            <ScrollToTop />
            <RootStyle>
              <Router />
            </RootStyle>
          </NotistackProvider>
        </ThemeSettings>
      </ThemeProvider>
    </MotionLazyContainer>
  );
}
